// FAQ live-search helpers (design renderVals.parts + filter logic).
// Tokens of 2+ characters match case-insensitively against the question text;
// matched fragments are returned as { t, hit } parts for the yellow highlight
// (#FFF0A8 + ring) in the question row.

const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const searchTokens = (query) =>
  (query || "")
    .trim()
    .split(/\s+/)
    .filter((t) => t.length > 1);

// Filter and highlighter must agree: `buildMatchParts` highlights per TOKEN,
// so the filter matches per token too — every token has to occur, word order
// is irrelevant. Matching the whole query as one contiguous phrase (the
// previous behaviour) meant "change password" found nothing although the
// question "How do I change my password while logged in?" exists and would
// have been highlighted. A query shorter than a token (1 character) keeps the
// plain substring match so typing the first letter still narrows the list.
export const questionMatchesQuery = (text, query) => {
  const trimmed = (query || "").trim().toLowerCase();
  if (!trimmed) return true;
  const low = (text || "").toLowerCase();
  const toks = searchTokens(query);
  if (!toks.length) return low.includes(trimmed);
  return toks.every((t) => low.includes(t.toLowerCase()));
};

export const buildMatchParts = (text, query) => {
  const toks = searchTokens(query);
  if (!toks.length) return [{ t: text, hit: false }];
  const re = new RegExp(`(${toks.map(escapeRegExp).join("|")})`, "ig");
  const low = toks.map((t) => t.toLowerCase());
  return String(text)
    .split(re)
    .filter((s) => s !== "")
    .map((s) => ({ t: s, hit: low.includes(s.toLowerCase()) }));
};
